(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {
        	'save': {
        		method: 'POST', 
        		isArray: false,
        		transformResponse: function (data, headers, status) {
        			if (status == 200) {
        				return {data: data};
        			}
                    return data;
                }
        	}
        });

        return service;
    }
})();
